import Typography from '@eduzz/houston-ui/Typography';
import React from 'react';
import HelpTip from 'v2/components/Shared/HelpTip';
import { Space } from 'v2/components/Shared/Space';

import { useStyles } from './styles';

export interface ICardProps {
  title: string;
  helpText?: React.ReactNode;
  total?: React.ReactNode;
  totalColor?: string;
  percent?: React.ReactNode;
  percentColor?: string;
}

const ValueCard = ({ title, helpText, total, totalColor = '#78909C', percent, percentColor = '#37474F' }: ICardProps) => {
  const classes = useStyles({
    totalColor,
    percentColor,
  });

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <Typography className={classes.title} size='xxs' weight='semibold'>
          {title}
        </Typography>
        <Space axis='horizontal' size={9.25} />
        {helpText && <HelpTip text={helpText} />}
      </header>
      <div className='m8' />
      <div className={classes.footer}>
        {total != null && (
          <Typography className={classes.total} size='md'>
            {total}
          </Typography>
        )}
        {percent != null && (
          <Typography className={classes.percent} size='sm' weight='semibold'>
            {percent}%
          </Typography>
        )}
      </div>
    </div>
  );
};

export default ValueCard;
